var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 20C5 18.1814 5.73328 16.4372 7.03854 15.1513C8.3438 13.8653 10.1141 13.1428 11.96 13.1428C13.8059 13.1428 15.5762 13.8653 16.8815 15.1513C18.1867 16.4372 19 18.1814 19 20M16.0198 8.00001C16.0198 10.2092 14.2021 12 11.9598 12C9.71751 12 7.89978 10.2092 7.89978 8.00001C7.89978 5.79087 9.71751 4 11.9598 4C14.2021 4 16.0198 5.79087 16.0198 8.00001Z",
    stroke: "#257FFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactInfo);
export default __webpack_public_path__ + "static/media/contact-info.c61b4ec6.svg";
export { ForwardRef as ReactComponent };